import {
  formDataRequest,
  getRequest,
  postRequest,
} from "../libs/AxiosService.util";

export async function serviceCreateCostCenter(params) {
  return await formDataRequest("cost-centres/create", params);
}
export async function serviceUpdateCostCenter(params) {
  return await postRequest("cost-centres/update", params);
}

export async function serviceDeleteCostCenter(params) {
  return await postRequest("cost-centres/delete", params);
}
export async function serviceGetCostCenterDetails(params) {
  return await postRequest("cost-centres/detail", params);
}
export async function serviceGetCostCenter(params) {
  return await postRequest("cost-centres", params);
}
export async function serviceCheckCostCenter(params) {
  return await postRequest("cost-centres/check", params);
}
